import React from "react";

const Burger = props => (
  <svg height={32} width={32} {...props}>
    <path d="M4 10h24a2 2 0 0 0 0-4H4a2 2 0 0 0 0 4zm24 4H4a2 2 0 0 0 0 4h24a2 2 0 0 0 0-4zm0 8H4a2 2 0 0 0 0 4h24a2 2 0 0 0 0-4z" fill="#e6e6e6"/>
  </svg>
);

export default Burger;



// WEBPACK FOOTER //
// ./src/components/Icons/Burger.js